import React, { FC } from 'react'

import { styled } from '@linaria/react'

import { VoidHandler } from 'common/types'

import { MeatballsSvg } from '../svgr/MeatballsSvg'

/**
 * https://stackoverflow.com/questions/34755666/what-is-the-hamburger-menu-icon-called-and-the-three-vertical-dots-icon-called
 */

export const Meatballs: FC<{ onClick?: VoidHandler }> = ({ onClick }) => {
  return (
    <Parent onClick={onClick}>
      <MeatballsSvg />
    </Parent>
  )
}

const Parent = styled.div`
  display: flex;
  background-color: var(--warm-opacity-hard);
  padding: 0 var(--spacing-8px);
  border-radius: var(--spacing-20px);
  width: min-content;
  cursor: pointer;
`
